import React from "react";
import { makeIconDef } from "./makeIconDef";

export const CircleIconDef = {
  circle: makeIconDef('circle', {
    regular: () => <circle cx="12" cy="12" r="8.5" stroke="currentColor" />,
    filled: () => <circle cx="12" cy="12" r="9" fill="currentColor" />,
  })
}